import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {}

type Language = 'it' | 'en';

export default function LanguageSwitcher({}: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation();
  
  const currentLanguage = i18n.language as Language;

  const changeLanguage = (lang: Language) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Group gap={6}>
      <Tooltip 
        label={t('language.switchToItalian', 'Passa a Italiano')}
        position="bottom"
        withArrow
      >
        <ActionIcon
          variant={currentLanguage === 'it' ? 'filled' : 'light'}
          color="blue"
          size="lg"
          radius="md"
          onClick={() => changeLanguage('it')}
          style={{
            transition: 'all 0.2s ease',
            background: currentLanguage === 'it' 
              ? 'rgba(102, 126, 234, 0.9)' 
              : 'rgba(102, 126, 234, 0.05)',
            border: `1px solid ${currentLanguage === 'it' 
              ? 'rgba(102, 126, 234, 0.9)' 
              : 'rgba(102, 126, 234, 0.15)'}`,
            fontSize: '20px',
            cursor: 'pointer'
          }}
          styles={{
            root: {
              '&:hover': {
                transform: 'scale(1.08)',
                background: currentLanguage === 'it' 
                  ? 'rgba(102, 126, 234, 1)' 
                  : 'rgba(102, 126, 234, 0.1)',
              }
            }
          }}
          aria-label={t('language.switchToItalian')}
        >
          🇮🇹
        </ActionIcon>
      </Tooltip>

      <Tooltip 
        label={t('language.switchToEnglish', 'Switch to English')}
        position="bottom"
        withArrow
      >
        <ActionIcon
          variant={currentLanguage === 'en' ? 'filled' : 'light'}
          color="blue"
          size="lg"
          radius="md"
          onClick={() => changeLanguage('en')}
          style={{
            transition: 'all 0.2s ease',
            background: currentLanguage === 'en' 
              ? 'rgba(102, 126, 234, 0.9)' 
              : 'rgba(102, 126, 234, 0.05)',
            border: `1px solid ${currentLanguage === 'en' 
              ? 'rgba(102, 126, 234, 0.9)' 
              : 'rgba(102, 126, 234, 0.15)'}`,
            fontSize: '20px',
            cursor: 'pointer'
          }}
          styles={{
            root: {
              '&:hover': {
                transform: 'scale(1.08)',
                background: currentLanguage === 'en' 
                  ? 'rgba(102, 126, 234, 1)' 
                  : 'rgba(102, 126, 234, 0.1)',
              }
            }
          }}
          aria-label={t('language.switchToEnglish')}
        >
          🇬🇧
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}
